export interface IVKYCDataPayload {
  token: string;
  loanApplicationID: string;
  pageName: string;
  userID: string;
  tabType?: TAB_TYPE;
  isLenderDashboard?: boolean;
  configResponse?: any;
}

export enum TAB_TYPE {
  VKYC = "V-KYC",
  VPD = "Video PD"
}
